<template>
    <div class="panel__list__item">
        <span>{{item.date_taken | formatDate}} {{item.date_closed ? '-' : '' }} {{item.date_closed | formatDate}}</span>
        <h3 class="purple">{{item.main_subject}}</h3>
        <h3>{{item.sub_subject}}</h3>
        <span>{{$t('dashboard.tests.closed')}}: {{item.date_closed ? $t('common.yes') : $t('common.no')}}</span>

        <div class="panel__list__item__actions">
            <span class="panel__list__item__action" @click="editTest">
                <i class="icons icon-pencil"></i>
                <a class="button--link">{{$t('common.edit')}}</a>
            </span>
            <span class="panel__list__item__action" @click="showDeleteTestModal">
                <i class="icons icon-trash"></i>
                <a class="button--link">{{$t('common.delete')}}</a>
            </span>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    import { GET_TESTS } from '@/store/modules/tests';

    @Component
    export default class TestsItem extends Vue {
        name = 'tests-item';

        @Prop()
        item;

        editTest() {
            this.$modal.show('test-modal', { test: this.item });
        }

        showDeleteTestModal() {
            const content = {
                title: this.$t('modals.delete_test.title'),
                message: this.$t('modals.delete_test.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteTest, test: this.item});
        }

        deleteTest({test}) {
            test.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.test.delete_success'));
                    this.$store.dispatch(GET_TESTS, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.test.delete_error')));
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/TestsItem.vue